import { IonModal } from '@ionic/react'
import React from 'react'
import './index.scss'

import shadowImg from '@img/mkt/get-shadow.png'
import cardrImg from '@img/mkt/cards-r.png'

interface IModalProps {
  name: string;
  title: string;
  des: string;
  reject?: () => void;
  resolve?: () => void;
}

const SuccessModal: React.FC<IModalProps> = (props: IModalProps) => {
  const { name, title, des, reject, resolve } = props
  return (

    <IonModal
      cssClass='give-succ-modal'
      isOpen
      onDidDismiss={reject}
    >
      <div className='modal-content'>
        <img className='shadow-image' src={shadowImg} alt='shadow' />
        <img className='card-image' src={cardrImg} alt='card' />
        <div className='coupon-name'>{name}</div>
        <div className='title'>{title}</div>
        <div className='des'>{des}</div>
        <div className='modal-btn' data-cypid='giveSuccModalConfirm' onClick={resolve}>{i18n.t('mkt.pointCard.confirm')}</div>
      </div>
    </IonModal>
  )
}

export default SuccessModal
